import { render, staticRenderFns } from "./ModalEditSeo.vue?vue&type=template&id=2b4ec89e&scoped=true&"
import script from "./ModalEditSeo.vue?vue&type=script&lang=js&"
export * from "./ModalEditSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4ec89e",
  null
  
)

export default component.exports